// src/store/slices/dialerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const dialerSlice = createSlice({
  name: 'dialer',
  initialState: {
    dialNumber: '',
    showKeyboard: true,
    showDynamicCallTimer: false,
  },
  reducers: {
    setDialNumber(state, action) {
      state.dialNumber = action.payload;
    },
    setShowKeyboard(state, action) {
      state.showKeyboard = action.payload;
    },
    resetDialer(state) {
      state.dialNumber = '';
    },
    setDynamicCallTimer(state, action) {
      state.showDynamicCallTimer = action.payload;
    },
  },
});

export const { setDialNumber, resetDialer, setShowKeyboard, setDynamicCallTimer } =
  dialerSlice.actions;
export const selectDialNumber = (state) => state.dialer.dialNumber;
export const selectShowKeyboard = (state) => state.dialer.showKeyboard;
export const selectShowDynamicCallTimer = (state) => state.dialer.showDynamicCallTimer;

export default dialerSlice.reducer;
